<h2 mat-dialog-title>Watch this project</h2>
<div mat-dialog-content>
    <p>You will be notified when changes are made to <strong>{{ data.projectName }}</strong>.</p>
    <p *ngIf="error" class="error">{{ error }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="isSaving" (click)="save()">Watch</button>
</div>